require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-search-and-rescue.json") })
        }
      }, "path---tags-search-and-rescue");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-search-and-rescue!./.cache/json/tags-search-and-rescue.json
// module id = 1035
// module chunks = 231608221292675